import lightbox from 'lightbox2';

window.lightbox = lightbox;
